exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cashBox{background-color:rgba(64,64,121,.55);border-radius:3px;color:#fff;font-size:16px}.cashBox .icon{font-size:22px}", ""]);

// exports
